import { FC, memo, useCallback, useEffect, useState } from "react";

import { ErrorMessage } from "../ErrorMessage";
import { InputColorProps } from "./InputColor.interface";
import { InputLabel } from "../InputLabel";
import { StyledFieldGroup } from "../InputLabel/InputLabel";
import { StyledInputColor } from "./InputColor.styled";

const InputColor: FC<InputColorProps> = ({
    autofocus = false,
    errorMessage,
    fullWidth = true,
    label,
    name,
    onBlur,
    onChange,
    onClick,
    state,
    value = '',
  ...inputProps
}) => {
 const [inputValue, setInputValue] = useState(value);
 const [shrink, setShrink] = useState<boolean>(!!value);
 const [focus, setFocus] = useState<boolean>(autofocus);

  useEffect(() => {
    setInputValue(value);
    setShrink(focus || !!value);
  }, [value])

  const onBlurHandler = useCallback((ev: React.FocusEvent<HTMLInputElement>) => {
      if (onBlur) {
        onBlur(ev);
      }
      
      if (!inputValue) {
        setShrink(false);
      }
      setFocus(false);
    }, [inputValue]);

  const onChangeHandler = useCallback((ev: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(ev);
    }

    setInputValue(ev.target.value);
  }, []);

  const onClickHandler = useCallback((ev: React.MouseEvent<HTMLInputElement>) => {
    ev.stopPropagation();

    if (onClick) {
      onClick(ev);
    }
  }, []);

  const showError = state === 'error' && errorMessage;

return (
    <StyledFieldGroup fullWidth={fullWidth}>
      <InputLabel shrink={shrink}>{label}</InputLabel>
      <StyledInputColor
        {...inputProps}
        fullWidth={fullWidth}
        name={name}
        onBlur={onBlurHandler}
        onChange={onChangeHandler}
        onClick={onClickHandler}
        state={state}
        type="color"
        value={inputValue}
      />
      {showError && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </StyledFieldGroup>
  );
}

export default memo(InputColor);